import React, { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { logout } from "../../store/actions/authActions";
import { useEffect } from "react";
import { getNotification } from "store/actions/notificationAction";
import { FaBell } from "react-icons/fa6";
import {
  Navbar,
  Container,
  NavbarBrand,
  Button,
  Modal,
  ModalBody,
} from "reactstrap";
import {
  useHistory,
  useLocation,
} from "react-router-dom/cjs/react-router-dom.min";
import Logo from "../../assets/img/custom/logo.png";
const AdminNavbar = (props) => {
  let dispatch = useDispatch();
  const history = useHistory();
  const location = useLocation();
  let auth = useSelector((state) => state.auth);
  const { unreadNotifications } = useSelector((state) => state.notification);
  const [showDot, setShowDot] = useState(false);
  const [logoutModal, setLogoutModal] = useState(false);

  const logoutToggle = () => {
    setLogoutModal(!logoutModal);
  };

  const handleBellClick = () => {
    setShowDot(false);
    history.push("/admin/notifications");
  };

  useEffect(() => {
    if (
      location.pathname !== "/admin/notifications" &&
      unreadNotifications?.length > 0
    ) {
      setShowDot(true);
    }
  }, [unreadNotifications, location.pathname]);

  useEffect(() => {
    if (location.pathname === "/school/notifications") {
      setShowDot(false);
    }
  }, [location.pathname]);

  useEffect(() => {
    if (auth.user?.id) {
      dispatch(getNotification(auth.user.id, auth.user.institute_name));
    }
  }, []);
  return (
    <>
      {auth.user.chatRate ? null : (
        <div>
          <marquee
            className="marqueeTagset d-none d-lg-block"
            direction="right"
            height="100px"
          >
            You need to set chat rate per minute on your profile section
          </marquee>
        </div>
      )}

      <Navbar
        className={
          auth.user.chatRate
            ? "navbar-topBanner bg-white d-none d-lg-flex"
            : "navbar-top bg-white d-none d-lg-flex"
        }
        expand="lg"
        id="navbar-main"
      >
        <NavbarBrand className="pt-0" href="/">
          <img className="mx-2" alt={Logo} src={Logo} height="70px" />
        </NavbarBrand>
        <Container fluid>
          <div className="mx-auto"></div>
          <div
            onClick={handleBellClick}
            className="position-relative mr-4"
            style={{ cursor: "pointer" }}
          >
            <FaBell size={24} className="text-dark" />
            {showDot && (
              <span
                className="position-absolute bg-danger rounded-circle blinking-dot"
                style={{
                  width: "10px",
                  height: "10px",
                  top: "-5px",
                  right: "-5px",
                  zIndex: 1,
                }}
              ></span>
            )}
          </div>
          <div className="d-flex align-items-center">
            <Button
              tag="a"
              href="mailto:jimbeecham@hotmail.com"
              className="bg-transparent border-0 text-dark mr-3"
              style={{ textDecoration: "none" }}
            >
              Report a Problem
            </Button>
            <Button className="bg-transparent border-0" onClick={logoutToggle}>
              Logout
            </Button>
          </div>
        </Container>
      </Navbar>
      <Modal isOpen={logoutModal} centered toggle={logoutToggle}>
        <ModalBody>
          <div className="text-center">
            <i
              className="fa fa-sign-out-alt text-primary"
              style={{ fontSize: 70 }}
            ></i>
            <br />
            <br />
            <span className="mt-5" style={{ fontSize: 30 }}>
              Are you sure?
            </span>
            <br />
            <br />
            <span className="mt-5" style={{ fontSize: 16 }}>
              You want to logout.
            </span>
            <br />
            <br />
            <br />
            <Button color="danger" onClick={logoutToggle}>
              Cancel
            </Button>{" "}
            <Button color="primary" onClick={() => dispatch(logout())}>
              Logout
            </Button>
          </div>
        </ModalBody>
      </Modal>
    </>
  );
};

export default AdminNavbar;
